'use strict';
import React from 'react';
import classnames from 'classnames';

window.React = React;

var VideoPreviewPlayer = React.createClass({

    displayName: 'VideoPreviewPlayer',

    propTypes: {
        videos: React.PropTypes.object.isRequired,
        show:   React.PropTypes.bool,
        poster: React.PropTypes.string
    },

    componentWillReceiveProps(nextProps) {
        // To prevent the video to continue buffering
        // we must set the src to an empty string directly on the Dom Node
        // Using just props simply didnt work
        const video = this.refs.video.getDOMNode();
        if (nextProps.show) {
            this._playTimeout && clearTimeout( this._playTimeout );
            this._stopTimeout && clearTimeout( this._stopTimeout );
            this.refs.video.props.children.map((source, idx) => {
                this.refs['source_' + idx].getDOMNode().src = source.props['hover-src'];
            });
            this._playTimeout = setTimeout( () => {
                video.volume = 0;
                video.load();
                video.play();
            }, 10 );
        } else {
            this._stopTimeout && clearTimeout( this._stopTimeout );
            this._playTimeout && clearTimeout( this._playTimeout );
            this.refs.video.props.children.map((source, idx) => {
                this.refs['source_' + idx].getDOMNode().src = '';
            });
            this._stopTimeout = setTimeout( () => {
                video.pause();
                video.load();
            }, 10 );
        }
    },

    // RENDER
    render() {
        if (this.props.videos.size === 0) {
            return null;
        }
        return (
            <video className={classnames('image__videoplayer', {'active': this.props.show})} ref="video" preload="metadata" poster={this.props.poster}>
                {this.props.videos.map((video, idx) => {
                    return (<source key={'source_' + idx} src="" ref={'source_' + idx} hover-src={video.get('url')} type={video.get('mimeType')} />);
                })}
            </video>
        );
    }
});

module.exports = VideoPreviewPlayer;



// WEBPACK FOOTER //
// ./app/components/thumb/videoPreviewPlayer.jsx